import generateTablePartDescription from './tablePart.js';

/**
 * Generates table parts description.
 * This is optional and will be ignored unless table is true. Only one table per sheet is supported.
 * @param  {object[]} options.table
 * @return {string}
 */
export default function generateTableParts({ table }) {
    if (table) {
        // `tableParts` format is described here:
        // https://learn.microsoft.com/en-us/dotnet/api/documentformat.openxml.spreadsheet.tableparts
        const { count, description } = generateTablePartDescription();
        if (description) {
            return `<tableParts count="${count}">${description}</tableParts>`;
        }
    }
    return '';
}
